// Енам для стилизации типа border у стилевых настроек
export enum BORDER_TYPE {
  ELLIPSE = 'ELLIPSE',
  SQUARE = 'SQUARE',
  ROUNDED_SQUARE = 'ROUNDED_SQUARE',
}

export const STYLE_SETTING_CLASS_NAME_PREFIX = 'STYLE_SETTING_'
